import React, { Component, Fragment } from 'react';

const formatMonto = (val) =>
    (Math.round(parseFloat(val) * 100) / 100)
        .toFixed(2)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

const formatTimer = (segundos) => {
    const m = Math.floor(segundos / 60).toString().padStart(2, '0');
    const s = (segundos % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
}

export default class CheckOutBox extends Component {
    constructor(props){
        super(props);
        this.onRemoveBoleto = this.onRemoveBoleto.bind(this);
        this.onVaciar = this.onVaciar.bind(this);
    }

    onRemoveBoleto = (e) => {
        this.props.onRemoveBoleto(e.target.getAttribute("id"));
    }

    onVaciar = (e) => {
        this.props.onVaciar();
    }

    render() {
        const { resumenData, promocionData, timerSegundos, showPago } = this.props;

        // Tomamos los valores del servicio de promociones si están disponibles,
        // si no, calculamos directo del resumen como antes (fallback)
        const totalBoletos = promocionData
            ? promocionData.subtotal
            : resumenData.reduce((t, u) => t + parseFloat(u.final_precio), 0);

        const totalCxs = promocionData
            ? promocionData.cxs
            : resumenData.reduce((t, u) => t + parseFloat(u.final_cxs), 0);

        const descuento   = promocionData ? promocionData.descuento : 0;
        const totalCarrito = promocionData
            ? promocionData.total
            : totalBoletos + totalCxs;

        const promocion = promocionData ? promocionData.promocion : null;

        const resumenOrdenado = [...resumenData].sort((a, b) => {
            const aAfectado = promocion && promocion.boletos_afectados
                ? promocion.boletos_afectados.find(b2 => b2.id == a.id)
                : null;
            const bAfectado = promocion && promocion.boletos_afectados
                ? promocion.boletos_afectados.find(b2 => b2.id == b.id)
                : null;

            const aDescuento = aAfectado && (aAfectado.final_precio < parseFloat(a.final_precio));
            const bDescuento = bAfectado && (bAfectado.final_precio < parseFloat(b.final_precio));

            return aDescuento === bDescuento ? 0 : aDescuento ? 1 : -1;
        });

        const data = resumenOrdenado.map((element) => {
            // Si hay boletos afectados, buscamos si este boleto tiene precio modificado
            const afectado = promocion && promocion.boletos_afectados
                ? promocion.boletos_afectados.find(b => b.id == element.id)
                : null;

            const precioFinal = afectado !== undefined && afectado !== null
                ? afectado.final_precio
                : parseFloat(element.final_precio);

            const cxsFinal = afectado !== undefined && afectado !== null
                ? afectado.final_cxs
                : parseFloat(element.final_cxs);

            const precioOriginal = parseFloat(element.final_precio) + parseFloat(element.final_cxs);
            const precioConDescuento = precioFinal + cxsFinal;
            const tieneDescuento = afectado !== null && afectado !== undefined && precioConDescuento < precioOriginal;

            return (
                <li key={element.id}>
                    <h6 className="subtitle">
                        <span>{element.localidad_nombre}</span>
                        <span>
                            {tieneDescuento && (
                                <span style={{
                                    textDecoration: 'line-through',
                                    color: '#999',
                                    fontSize: '0.85em',
                                    marginRight: '6px'
                                }}>
                                    $ {formatMonto(precioOriginal)}
                                </span>
                            )}
                            $ {formatMonto(precioConDescuento)}
                        </span>
                    </h6>
                    <div className="info">
                        <span>
                            {element.localidad_nombre !== element.seccion_nombre && element.seccion_nombre}
                            {element.fila_etiqueta != null && (' ' + element.fila_etiqueta + element.asiento_etiqueta)}
                        </span>
                        {!showPago && (
                            <span>
                                <a href="#0" id={element.id} onClick={this.onRemoveBoleto}>Eliminar</a>
                            </span>
                        )}
                    </div>
                </li>
            );
        });

        if (resumenData.length > 0) {
            return (
                <Fragment>
                    <div>
                        <div className="booking-summery bg-one">
                            <h4 className="title">Carrito de Compra</h4>

                            {/* Timer */}
                            {timerSegundos !== null && (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'baseline',
                                    justifyContent: 'center',
                                    gap: '10px',
                                    marginBottom: '10px'
                                }}>
                                    <span style={{
                                        fontSize: '40px',
                                        fontWeight: '500',
                                        color: timerSegundos <= 60 ? '#E24B4A' : '#BA7517',
                                        letterSpacing: '-0.5px',
                                        lineHeight: '1',
                                        animation: timerSegundos <= 60 ? 'pulseRed 1s ease-in-out infinite' : 'none'
                                    }}>
                                        {formatTimer(timerSegundos)}
                                    </span>
                                    <span style={{
                                        fontSize: '16px',
                                        color: timerSegundos <= 60 ? '#E24B4A' : '#BA7517',
                                        opacity: '0.8'
                                    }}>
                                        tiempo restante
                                    </span>
                                    <style>{`
                                        @keyframes pulseRed {
                                            0%, 100% { opacity: 1; }
                                            50% { opacity: 0.6; }
                                        }
                                    `}</style>
                                </div>
                            )}

                            {/* Badge de promoción */}
                            {promocion && (
                                <div style={{
                                    background: '#2ecc71',
                                    color: '#fff',
                                    borderRadius: '4px',
                                    padding: '6px 10px',
                                    marginBottom: '10px',
                                    fontSize: '0.85em',
                                    fontWeight: '600',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px'
                                }}>
                                    <span>🏷</span>
                                    <span>{promocion.nombre}</span>
                                </div>
                            )}

                            <ul>{data}</ul>

                            <ul className="side-shape">
                                <li>
                                    <span className="info">
                                        <span>Boletos</span>
                                        <span>$ {formatMonto(totalBoletos)}</span>
                                    </span>
                                    <span className="info">
                                        <span>Cargo por Servicio</span>
                                        <span>$ {formatMonto(totalCxs)}</span>
                                    </span>
                                    {descuento > 0 && (
                                        <span className="info" style={{ color: '#2ecc71', fontWeight: '600' }}>
                                            <span>Descuento</span>
                                            <span>- $ {formatMonto(descuento)}</span>
                                        </span>
                                    )}
                                </li>
                            </ul>
                        </div>

                        <div className="proceed-area text-center">
                            <h6 className="subtitle">
                                <span>Total de Compra</span>
                                <span>$ {formatMonto(totalCarrito)}</span>
                            </h6>
                            {!showPago && (
                                <button
                                    className="custom-button back-button"
                                    style={{ marginRight: '20px', marginBottom: '20px' }}
                                    onClick={() => {
                                        if (window.confirm('Perderás tus boletos asignados ¿Estás seguro?'))
                                            this.onVaciar();
                                    }}
                                >
                                    Vaciar Carrito
                                </button>
                            )}
                            {!showPago && (
                                <button
                                    className="custom-button back-button"
                                    style={{ marginBottom: '20px' }}
                                    onClick={this.props.onPagar}
                                >
                                    Pagar
                                </button>
                            )}
                        </div>
                    </div>
                </Fragment>
            );
        } else {
            return (
                <Fragment>
                    <div>
                        <div className="booking-summery bg-one">
                            <h4 className="title">Carrito de Compra</h4>
                            <ul>
                                <li>Tu carrito está vacío.</li>
                            </ul>
                            <ul className="side-shape">
                                <li><strong>¡No esperes más!</strong> Selecciona tus boletos preferidos ahora que están disponibles.</li>
                            </ul>
                        </div>
                    </div>
                </Fragment>
            );
        }
    }
}